// EditProfilePopup.jsx

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./EditProfilePopup.css";

const EditProfilePopup = ({ profile = {}, setProfile = () => {} }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: profile.fullName || "",
    email: profile.email || "",
    phone: profile.phone || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* Save + back to admin profile */
  const handleSave = () => {
    setProfile(formData);
    navigate("/admin-profile");
  };

  /* Close popup */
  const handleClose = () => {
    navigate("/admin-profile");
  };

  return (
    <div className="EditProfilePopup-overlay">
      <div className="EditProfilePopup-box">
        {/* X Close */}
        <button className="EditProfilePopup-close" onClick={handleClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15 5L5 15"
              stroke="#3E3E3E"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5 5L15 15"
              stroke="#3E3E3E"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        {/* Title */}
        <h2 className="EditProfilePopup-title">Edit Profile</h2>

        {/* Full Name */}
        <label className="EditProfilePopup-label">Full Name</label>

        <input
          type="text"
          name="fullName"
          placeholder="Prachi Kunjir"
          value={formData.fullName}
          onChange={handleChange}
          className="EditProfilePopup-input"
        />

        {/* Email */}
        <label className="EditProfilePopup-label">Email Address</label>

        <input
          type="email"
          name="email"
          placeholder="prachi.kunjir@saprahouse.com"
          value={formData.email}
          onChange={handleChange}
          className="EditProfilePopup-input"
        />

        {/* Phone */}
        <label className="EditProfilePopup-label">Phone Number</label>

        <input
          type="text"
          name="phone"
          placeholder="+91 98765 43210"
          value={formData.phone}
          onChange={handleChange}
          className="EditProfilePopup-input"
        />

        {/* Buttons */}
        <div className="EditProfilePopup-buttons">
          <button className="EditProfilePopup-cancel" onClick={handleClose}>
            Cancel
          </button>

          <button className="EditProfilePopup-save" onClick={handleSave}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProfilePopup;
